import { createAsyncThunk } from '@reduxjs/toolkit';

import { UserSettingsService } from 'api';

import { asyncPayloadCreator } from 'utils';

import { ChangePasswordProps } from 'models/api';

export const changePassword = createAsyncThunk(
	'userSettings/changePassword',
	async (credentials: ChangePasswordProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, UserSettingsService.changePassword),
);
